import {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import {OhipConfig} from "crqlar-react-common/dist/models/integrations/ohip/ohip.config";
import ImportLogsTable from "../../common/ImportLogsTable";

interface Props {
    configData: UseEntityData<OhipConfig>
}

const Logs = ({configData}: Props) => (
    <ImportLogsTable
        configId={configData.item.id}
        tableId="system-ohip-import-logs"
    />
);

export default Logs;
